module.exports = __webpack_public_path__ + "img/MoonSword 1b.31d31f7c.png";